import { render, staticRenderFns } from "./support-portal-layout.vue?vue&type=template&id=5e1383dc&scoped=true&"
import script from "./support-portal-layout.vue?vue&type=script&lang=js&"
export * from "./support-portal-layout.vue?vue&type=script&lang=js&"
import style0 from "./support-portal-layout.vue?vue&type=style&index=0&id=5e1383dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1383dc",
  null
  
)

export default component.exports